import { render } from "./AssessmentResultPage.vue?vue&type=template&id=466e7c2d&scoped=true"
import script from "./AssessmentResultPage.vue?vue&type=script&lang=js"
export * from "./AssessmentResultPage.vue?vue&type=script&lang=js"

import "./AssessmentResultPage.vue?vue&type=style&index=0&id=466e7c2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466e7c2d"]])

export default __exports__